import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './itemsByUpcStatusDialog.html'

/**
 * Configures dialog Items by Upc (preset `tmrItemsByUpcStatus`).
 *
 * @type {ngConfig}
 */
function tmrItemsByUpcStatusDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrItemsByUpcStatus', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: 'tmrItemsByUpcStatusDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        upc: '?',
        epcs: [],
      },
      resolve: {
        productImageEnabled: /*@ngInject*/ TmrAppConfiguration =>
          TmrAppConfiguration.get('product.image.enabled'),
      },
    }),
  })
}

export { tmrItemsByUpcStatusDialogConfig as config }

/**
 * Controller of Dialog {@link tmrItemsByUpcStatusDialogConfig tmrItemsByUpcStatus}.
 *
 * @type {ngController}
 */
export class tmrItemsByUpcStatusDialogController extends tmrDialogController {
  constructor($mdDialog, $transitions, Item, Product) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Item, Product })
  }

  $onInit() {
    super.$onInit()
    this.itemsByEpc = {}
    if (this.epcs.length) {
      this.Item.query({ epc: this.epcs }).$promise.then(items =>
        items.forEach(item => (this.itemsByEpc[item.epc] = item))
      )
    }
    this.product = this.upc ? this.Product.getByUpc(this.upc) : {}
  }
}
